
<template functional>
    <a-sub-menu :key="props.subMenuArr.realPath" :title="props.subMenuArr.name">
 
        <template v-for="(subMenuItem, subMenuKey) in props.subMenuArr.children">
 
            <template v-if="subMenuItem.children.filter(item=>{return item.path.indexOf('action') == -1}).length >= 1">
                <!--  vue组件自己调用自己  -->
                <sub-Menu :key="subMenuKey" :subMenuArr="subMenuItem" ></sub-Menu>
            </template>
                <template v-else-if="subMenuItem.isAuthed">
                    <!--导航栏-->
                    <a-menu-item :key="subMenuItem.realPath">
                        <router-link :to="subMenuItem.realPath">{{subMenuItem.name.split('-').reverse()[0]}}</router-link> 
                    </a-menu-item>
                </template>
 
        </template>
    </a-sub-menu>
</template>
 
<script>
export default {
    name: 'SubMenu',
    data() {
        return {
        };
    },
    components: {},
    props: {
        subMenuArr: {},
    },
    mounted() {

    }
}
</script>
 
<style scoped>
 
</style>